import packageJson from '../../../package.json';

const _VERSION_FIELD_NAME = '__version__';
const _VERSION_FIELD_DEFAULT_VALUE = '';

function getAppVersion() {
  return (
    window.localStorage.getItem(_VERSION_FIELD_NAME) ||
    _VERSION_FIELD_DEFAULT_VALUE
  );
}

function setAppVersion(version: string) {
  window.localStorage.setItem(_VERSION_FIELD_NAME, version);
}

function getPackageVersion() {
  return packageJson.version;
}

export {
  _VERSION_FIELD_DEFAULT_VALUE,
  _VERSION_FIELD_NAME,
  getAppVersion,
  getPackageVersion,
  setAppVersion,
};
